import styled from "styled-components";

export const HeroContainer = styled.div`
  background: transparent;
  display: flex;
  min-height: 100vh;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 100px 30px 80px;
  @media (max-width: 960px) {
    padding: 90px 16px 60px;
  }
  z-index: 1;
`;

export const HeroBg = styled.div`
  position: absolute;
  display: flex;
  justify-content: end;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-width: 1360px;
  overflow: hidden;
  padding: 0 30px;
  top: 50%;
  left: 50%;
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);

  @media (max-width: 960px) {
    justify-content: center;
    padding: 0 0px;
  }
`;

export const HeroInnerContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 130px;
  width: 100%;
  max-width: 1100px;

  @media (max-width: 960px) {
    flex-direction: column;
  }
`;
export const HeroLeftContainer = styled.div`
  width: 100%;
  order: 1;
  @media (max-width: 960px) {
    order: 2;
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media (max-width: 640px) {
    order: 2;
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const HeroRightContainer = styled.div`
  width: 100%;
  display: flex;
  order: 2;
  justify-content: end;
  gap: 12px;
  @media (max-width: 960px) {
    order: 1;
    justify-content: center;
    align-items: center;
    margin-bottom: 80px;
  }

  @media (max-width: 640px) {
    margin-bottom: 30px;
  }
`;

export const Img = styled.img`
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 380px;
  max-height: 380px;
  border-radius: 50%;
  border: 3px solid ${({ theme }) => theme.primary};
  box-shadow: 0 0 40px ${({ theme }) => theme.glow};
  object-fit: cover;

  @media (max-width: 768px) {
    max-width: 400px;
    max-height: 400px;
  }

  @media (max-width: 640px) {
    max-width: 280px;
    max-height: 280px;
  }
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: 50px;
  color: ${({ theme }) => theme.text_primary};
  line-height: 1.2;
  @media (max-width: 960px) {
    text-align: center;
  }

  @media (max-width: 640px) {
    font-size: 32px;
    line-height: 1.25;
    margin-bottom: 8px;
  }
`;

export const TitleName = styled.span`
  white-space: nowrap;
  display: inline-block;
`;

export const TextLoop = styled.div`
  font-weight: 600;
  font-size: 32px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  color: ${({ theme }) => theme.text_primary};
  line-height: 1.35;
  width: 100%;
  max-width: 620px;

  @media (max-width: 960px) {
    align-items: center;
    text-align: center;
  }

  @media (max-width: 640px) {
    font-size: 22px;
    max-width: 100%;
    margin-bottom: 16px;
  }
`;

export const TextLoopLabel = styled.span`
  color: ${({ theme }) => theme.text_primary};
  white-space: nowrap;
`;

export const Span = styled.span`
  display: block;
  width: 100%;
  min-width: 320px;
  min-height: 2.75em;
  background: ${({ theme }) => theme.gradient};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 1.35;
  word-wrap: break-word;
  overflow-wrap: break-word;

  @media (max-width: 640px) {
    min-width: 260px;
    min-height: 2.5em;
  }
`;

export const SubTitle = styled.div`
  font-size: 20px;
  line-height: 32px;
  margin-bottom: 42px;
  color: ${({ theme }) => theme.text_primary + 95};

  @media (max-width: 960px) {
    text-align: center;
  }

  @media (max-width: 640px) {
    font-size: 16px;
    line-height: 32px;
  }
`;

export const ResumeButton = styled.a`
    appearance: button;
    text-decoration: none;
    width: 95%;
    max-width: 280px;
    text-align: center;
    padding: 14px 0;
    color: ${({ theme }) => theme.white};
    border-radius: 12px;
    cursor: pointer;
    font-size: 18px;
    font-weight: 600;
    transition: all 0.3s ease-in-out;
    background: ${({ theme }) => theme.gradient};
    border: none;
    box-shadow: 0 4px 20px ${({ theme }) => theme.glow};
    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 30px ${({ theme }) => theme.glow};
    }
    @media (max-width: 640px) {
        padding: 12px 0;
        font-size: 16px;
    }
`;
